import { Step } from "react-joyride";

export const getSteps = (isMobile: boolean): Step[] => [
    {
        target: 'body',
        content: 
        <div>
            <h1>Welcome to PBS Connect</h1>
            <div>We have redesigned your home page to make it faster to find what you need. This quick tour will show you what's new and where things live. It takes less than 2 minutes.</div>
        </div>,
        placement: 'center'
    },
    {
        target: '.links-menu',
        content: <div>
            <h1>This is your links panel</h1>
            <div>This is your central hub for every tool and resource you can use. Links are organized by category so you can jump directly to what you need without searching.</div>
        </div>,
        placement: 'right'
    },
    {
        target: '.links-tab',
        content:
            <div>
                <h1>Three ways to navigate your links.</h1>
                <div>
                    'All Links' shows everything available to you. 'Recent Links' recalls where you've been. 'Favorites' lets you pin the tools you use the most.  
                </div>
            </div>,
        placement: 'bottom'
    },
    {
        target: '.favorite-links',
        content:
            <div>
                <h1>Pin your most-used links as Favorites.</h1>
                <div>Click the star icon on any link to save it here.</div>
            </div>,
        placement: 'bottom'
    },
    {
        target: isMobile ? '.widget-launcher-mobile' : '.widget-bar',
        content: <div> 
                <h1>My Tools</h1>
                <div>Find tools such as your E-mail, Calendar and My Provider Data through these quick access buttons</div>
            </div>,
        placement: 'left'
    },
    {
        target: '.notification-text',
        content:
            <div>
                <h1>Your notifications badge shows pending items that need your attention.</h1>
                <div>Click it to see the full list and act on them directly from here</div>
            </div>
        ,
        placement: 'bottom'
    },
    {
        target: isMobile ? '.home-clients-mobile' : '.home-clients-desktop',
        content:
            <div>
                <h1>Access your client files here.</h1>
                <div>Start or update behavior plans, complete data collection tasks, update client availability, or access time entry directly.</div>
                <div>Select Openings for Me to discover new cases and express interest in joining a client's case. </div>
            </div>
        ,
        placement: isMobile ? 'bottom' : 'right'
    },
    {
        target: '.app-launcher',
        content:
            <div>
                <h1>Quick access to your core apps without digging through menus.</h1>
                <div>From here you can jump directly into Time Entry, Data Collection, and our learning platform.</div>
            </div>
        ,
        placement: 'bottom'
    },
    {
        target: '.groups',
        content:
            <div>
                <h1>Find chats in the My Groups section</h1>
                <div>Keep in contact with your regional team, treatment teams, and staffing groups to connect with potential new cases.</div>
            </div>,
        placement: 'top'
    },
    {
        target: '.announcements',
        content:
            <div>
                The announcements section will share news and updates with you from PBS and your regional team.
            </div>,
        placement: 'top'
    }
]